var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "rename-folder-modal",
            title: "Rename Folder",
            centered: "",
          },
          on: {
            ok: _vm.renameFolder,
            cancel: _vm.cancelRenameFolder,
            hidden: _vm.cancelRenameFolder,
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function ({ ok, cancel }) {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: {
                        click: function ($event) {
                          return cancel()
                        },
                      },
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: !_vm.renamingFolderName.trim(),
                      },
                      on: {
                        click: function ($event) {
                          return ok()
                        },
                      },
                    },
                    [_vm._v("\n        Rename\n      ")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Folder name" } },
            [
              _c("b-form-input", {
                attrs: { placeholder: "Enter folder name" },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.renameFolder.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.renamingFolderName,
                  callback: function ($$v) {
                    _vm.renamingFolderName = $$v
                  },
                  expression: "renamingFolderName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "brief-folder-rename-modal",
            title: "Rename linked brief folder",
            centered: "",
          },
          on: { hidden: _vm.cancelBriefFolderRename },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.cancelBriefFolderRename },
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-primary" },
                      on: {
                        click: function ($event) {
                          return _vm.confirmBriefFolderRename("folder_only")
                        },
                      },
                    },
                    [_vm._v("\n        Just the folder\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.confirmBriefFolderRename("both")
                        },
                      },
                    },
                    [_vm._v("\n        Rename both\n      ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("p", { staticClass: "mb-2" }, [
            _vm._v("\n      This folder is linked to the brief\n      "),
            _c("strong", [_vm._v(_vm._s(_vm.briefRenameBriefTitle))]),
            _vm._v(".\n      Rename the brief too?\n    "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-muted small mb-0" }, [
            _vm._v(
              "\n      Choosing “Just the folder” stops automatic syncing. The brief will get a new folder the next time assets are added.\n    "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "folder-list-container" }, [
        _c("div", { staticClass: "folder-sticky-header" }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mb-3",
            },
            [
              _c("div", { staticClass: "search-container flex-grow-1 mr-3" }, [
                _c("div", { staticClass: "search-input-wrapper" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchQuery,
                        expression: "searchQuery",
                      },
                    ],
                    staticClass: "search-input",
                    attrs: {
                      type: "text",
                      placeholder: "Search in this folder...",
                    },
                    domProps: { value: _vm.searchQuery },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.performSearch.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.searchQuery = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass: "search-icon",
                      attrs: { width: "13", height: "13" },
                    },
                    [
                      _c("use", {
                        attrs: { href: "/img/icons/sprite.svg#search-big" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.searchQuery
                    ? _c(
                        "button",
                        {
                          staticClass: "clear-search-btn",
                          on: { click: _vm.clearSearch },
                        },
                        [_c("i", { staticClass: "cil-x" })]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "b-btn",
                    {
                      staticClass:
                        "c-top-bar__reset-button c-top-bar__settings-button c-top-bar__search--button ml-2",
                      attrs: { title: "New folder" },
                      on: { click: _vm.createFolder },
                    },
                    [
                      _c("FolderPlusIcon", {
                        staticClass: "c-top-bar__search--new-folder-button",
                        attrs: { width: 12, height: 12 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mb-3",
            },
            [
              _c("BreadcrumbItem", {
                attrs: { breadcrumbs: _vm.breadcrumbs },
                on: { goTo: _vm.goToFolder },
              }),
              _vm._v(" "),
              _vm.allowSelectAll && _vm.allowMultipleSelection
                ? _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    [
                      !_vm.hasSelectedItems
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "select-all-btn",
                              on: { click: _vm.selectAllItems },
                            },
                            [_vm._v("\n            Select All\n          ")]
                          )
                        : _c(
                            "b-btn",
                            {
                              staticClass: "reset-all-btn",
                              on: { click: _vm.clearSelectedItems },
                            },
                            [
                              _vm._v(
                                "\n            Clear Selections\n          "
                              ),
                            ]
                          ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.items.length || _vm.isListLoading || _vm.creatingFolder
          ? _c(
              "div",
              { staticClass: "folder-scroll-area" },
              [
                _vm.isListLoading || _vm.creatingFolder
                  ? [
                      _c(
                        "div",
                        { staticClass: "folders-grid" },
                        _vm._l(_vm.pageSize, function (n) {
                          return _c(
                            "div",
                            {
                              key: n,
                              staticClass: "w-100 h-100",
                              staticStyle: { "min-height": "167px" },
                            },
                            [
                              _c("b-skeleton", {
                                attrs: { width: "100%", height: "88%" },
                              }),
                              _vm._v(" "),
                              _c("b-skeleton"),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]
                  : [
                      _vm.isSearchActive &&
                      _vm.items.length &&
                      _vm.wasEnterPressed
                        ? _c(
                            "b-alert",
                            {
                              staticClass: "mb-3",
                              attrs: { show: "", variant: "info" },
                            },
                            [
                              _vm._v(
                                "\n          Found " +
                                  _vm._s(_vm.totalCount) +
                                  " result" +
                                  _vm._s(_vm.totalCount > 1 ? "s" : "") +
                                  ' for "' +
                                  _vm._s(_vm.searchQuery) +
                                  '"\n        '
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isSearchActive &&
                      !_vm.items.length &&
                      !_vm.isListLoading
                        ? _c(
                            "b-alert",
                            {
                              staticClass: "mb-3",
                              attrs: { show: "", variant: "warning" },
                            },
                            [
                              _vm._v(
                                '\n          No results found for "' +
                                  _vm._s(_vm.searchQuery) +
                                  '"\n        '
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "section-container" },
                        [
                          _vm.folderItems.length
                            ? _c("ItemGrid", {
                                staticClass: "folder-items folders-grid",
                                attrs: {
                                  items: _vm.folderItems,
                                  "is-selected": _vm.isSelected,
                                  columns: 4,
                                  gap: 16,
                                  "item-props-for": (item) => ({
                                    showEditButton: _vm.canRenameFolder(item),
                                  }),
                                },
                                on: {
                                  "item-click": _vm.onSelectedItem,
                                  "item-dblclick": _vm.dblHandler,
                                  edit: _vm.startRenamingFolder,
                                },
                              })
                            : !_vm.isSearchActive
                            ? _c(
                                "b-alert",
                                {
                                  staticClass: "mb-4",
                                  attrs: { show: "", variant: "info" },
                                },
                                [
                                  _vm._v(
                                    "\n            No folders available\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "section-container" },
                        [
                          _vm.otherItems.length
                            ? _c("ItemGrid", {
                                staticClass: "folders-grid",
                                attrs: {
                                  items: _vm.otherItems,
                                  "is-selected": _vm.isSelected,
                                  columns: 4,
                                  gap: 16,
                                  "item-props": {
                                    isAvailableOverlay: _vm.availableOverlay,
                                  },
                                },
                                on: {
                                  "item-click": _vm.onSelectedItem,
                                  "item-dblclick": _vm.fileDoubleClickHandler,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
              ],
              2
            )
          : _c(
              "div",
              { staticClass: "folder-scroll-area" },
              [
                _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                  _vm._v("\n        Folder is empty\n      "),
                ]),
              ],
              1
            ),
        _vm._v(" "),
        _c("div", { staticClass: "folder-sticky-footer" }, [
          _vm.selectedItems.length
            ? _c("div", { staticClass: "selection-summary" }, [
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(
                    _vm._s(_vm.selectedItems.length) +
                      " item" +
                      _vm._s(_vm.selectedItems.length > 1 ? "s" : "") +
                      " selected"
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center align-items-center item-pagination",
            },
            [
              _c("ItemPagination", {
                attrs: {
                  "per-page": _vm.pageSize,
                  "total-rows": _vm.totalCount,
                  disabled: _vm.isListLoading,
                },
                on: { change: _vm.onChangePage },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }